module.exports = __webpack_public_path__ + "img/Loading_akkodis_logo_2.88047587.svg";